import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

const LoadingOverlay = () => (
  <div className="loading-overlay" style={overlayStyle}>
    <div className="loading-spinner" style={spinnerStyle}></div>
    <p>Loading...</p>
  </div>
);

const overlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const spinnerStyle = {
  width: "40px",
  height: "40px",
  border: "4px solid rgba(0, 0, 0, 0.3)",
  borderTop: "4px solid #000",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};

const GlbModel = () => {
  const mountRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const modelPath = "https://monashtp21.s3.ap-southeast-2.amazonaws.com/a3.glb";

  useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    const renderer = new THREE.WebGLRenderer({ antialias: true });

    renderer.setSize(window.innerWidth, window.innerHeight);
    mountRef.current.appendChild(renderer.domElement);
    renderer.setClearColor(0xaaaaaa);

    if (mountRef.current) {
      mountRef.current.appendChild(renderer.domElement);
    }

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    scene.add(ambientLight);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
    directionalLight.position.set(5, 1, 10).normalize();
    scene.add(directionalLight);

    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.25;
    controls.enableZoom = true;

    const loader = new GLTFLoader();
    loader.load(
      modelPath,
      (gltf) => {
        gltf.scene.scale.set(0.5, 0.5, 0.5);
        scene.add(gltf.scene);

        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            console.log("Child name:", child.name);
            if (
              child.name === "Mesh79" ||
              child.name === "Mesh80" ||
              child.name === "Mesh81"
            ) {
              child.material = new THREE.MeshStandardMaterial({
                color: 0xff0000,
              });
            } else if (
              child.name === "Mesh30" ||
              child.name === "Mesh32" ||
              child.name === "Mesh34" ||
              child.name === "Mesh36" ||
              child.name === "Mesh38" ||
              child.name === "Mesh40" ||
              child.name === "Mesh42" ||
              child.name === "Mesh44" ||
              child.name === "alarm1"
            ) {
              child.material = new THREE.MeshStandardMaterial({
                color: 0x00ff00,
              });
            } else if (
              child.name === "Mesh24_1" ||
              child.name === "Mesh27_1" ||
              child.name === "Mesh28_1" ||
              child.name === "Mesh29_1"
            ) {
              child.material = new THREE.MeshStandardMaterial({
                color: 0x0000ff,
              });
            } else {
              child.material = new THREE.MeshStandardMaterial({
                color: 0xffffff,
              });
            }
          }
        });

        const box = new THREE.Box3().setFromObject(gltf.scene);
        const center = box.getCenter(new THREE.Vector3());
        gltf.scene.position.x += gltf.scene.position.x - center.x;
        gltf.scene.position.y += gltf.scene.position.y - center.y;
        gltf.scene.position.z += gltf.scene.position.z - center.z;

        const size = box.getSize(new THREE.Vector3());
        const maxDim = Math.max(size.x, size.y, size.z);
        const fov = camera.fov * (Math.PI / 180);
        let cameraZ = Math.abs((maxDim / 2) * Math.tan(fov * 2));
        camera.position.z = cameraZ * 1.5;

        controls.maxDistance = cameraZ * 10;
        controls.target.set(0, 0, 0);
        controls.update();

        setIsLoading(false);
      },
      (progress) => {
        console.log(
          "Loading progress:",
          (progress.loaded / progress.total) * 100 + "%"
        );
      },
      (error) => {
        console.error("An error occurred while loading the model:", error);
        setIsLoading(false);
      }
    );

    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };
    window.addEventListener("resize", handleResize);

    const animate = () => {
      requestAnimationFrame(animate);
      controls.update();
      renderer.render(scene, camera);
    };
    animate();

    return () => {
      window.removeEventListener("resize", handleResize);
      if (mountRef.current && renderer.domElement) {
        mountRef.current.removeChild(renderer.domElement);
      }
      renderer.dispose();
    };
  }, []);

  return (
    <div style={{ position: "relative", width: "100%", height: "100vh" }}>
      {isLoading && <LoadingOverlay />}
      <div ref={mountRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
};

export default GlbModel;
